<template>
  <div class="viewer-section">
    <div class="viewer-header">
      <h2>JSON File</h2>
      <div class="header-actions">
        <button @click="$emit('replace')" class="btn btn-primary">
          <font-awesome-icon icon="sync" />
          Replace File
        </button>
      </div>
    </div>
    
    <div v-if="loading" class="loading">Loading file...</div>
    <div v-else-if="error" class="error">
      {{ error }}
    </div>
    <div v-else-if="jsonData" class="json-content">
      <div class="file-info-bar">
        <span>Size: {{ formatFileSize(fileStats?.size || 0) }}</span>
        <span>Modified: {{ formatDate(fileStats?.modified) }}</span>
      </div>
      
      <div class="json-display">
        <pre><code>{{ JSON.stringify(jsonData, null, 2) }}</code></pre>
      </div>
      
      <div class="viewer-actions">
        <button @click="downloadFile" class="btn btn-success">
          <font-awesome-icon icon="download" />
          Download
        </button>
      </div>
      
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

interface FileStats {
  size: number;
  created: string;
  modified: string;
}

export default defineComponent({
  name: 'JsonViewer',
  props: {
    jsonData: {
      type: Object as PropType<any>,
      default: null
    },
    fileStats: {
      type: Object as PropType<FileStats>,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['replace', 'message'],
  methods: {
    downloadFile() {
      if (this.jsonData) {
        const blob = new Blob([JSON.stringify(this.jsonData, null, 2)], {
          type: 'application/json'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'index.json';
        a.click();
        URL.revokeObjectURL(url);
      }
    },
    
    formatFileSize(bytes: number): string {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
    formatDate(dateString: string): string {
      return new Date(dateString).toLocaleString();
    },
  },
});
</script>

<style lang="scss" scoped>
@use './styles/uploadJsonFile.scss' as *;
</style>